// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__1Kd6p","slider":"style_slider__3FWfq","round":"style_round__3mRiM","switchContainer":"style_switchContainer__200dt"};